import { Outlet } from "react-router-dom";
import MobileBottomNav from "@/components/MobileBottomNav";

/**
 * Like SidebarLayout, but without the desktop left navigation — the content
 * spans the full width. Used for immersive sections (Companies) that bring
 * their own in-page navigation, mirroring the sidebar-less /docs experience.
 * The mobile bottom nav is kept so small screens can still navigate.
 */
const FullWidthLayout = () => (
  <div className="min-h-[calc(100vh-5rem)] bg-gray-50">
    <div className="max-w-6xl mx-auto px-3 sm:px-4 py-4 md:py-6 pb-24 md:pb-6">
      <Outlet />
    </div>
    <MobileBottomNav />
  </div>
);

export default FullWidthLayout;
